import {
    GET_SMS_PROVIDER_SUCCESS,
    GET_SMS_PROVIDER_FAILED,
    RESET_GET_SMS_PROVIDER,
    LOADING_GET_SMS_PROVIDER,
    NETWORK_ERROR_GET_SMS_PROVIDER,
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_GET_SMS_PROVIDER:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case GET_SMS_PROVIDER_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case GET_SMS_PROVIDER_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_GET_SMS_PROVIDER:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_GET_SMS_PROVIDER:
			return (state = initialState);
		default:
			return state;
	}
};
